import { gql } from '@apollo/client';
import { createContext } from 'libs/react';
import { useContext } from 'libs/react';
import { useEffect } from 'libs/react';
import { useQuery } from 'libs/react';
import { decode } from 'libs/util/json';
import { Error } from 'components/Error';
import { captureCampaignAttribution } from 'components/domain/campaignAttribution';
import { CookieConsentBanner } from 'components/domain/CookieConsentBanner';
import { useGtmConsent } from 'components/domain/useGtmConsent';
import { DomainFragment } from 'graphql/Domain/fragments/DomainFragment';
import { getPrivacyConsentConfig } from 'helpers/privacyConsent';
import i18n from 'components/translation/i18n';
import { React } from 'libs/react';
/**
 * @component DomainProvider
 * @since 1.0.0
 */
export function DomainProvider(props) {
    var _a, _b, _c;
    const [data, ready, error] = useQuery(DomainQuery, {
        fetchPolicy: 'cache-first',
        variables: {
            input: {
                host: window.location.hostname
            }
        }
    });
    const domain = data === null || data === void 0 ? void 0 : data.domain;
    const options = domain ? decode(domain.options) : {};
    const gtm = useGtmConsent((_a = domain === null || domain === void 0 ? void 0 : domain.host) !== null && _a !== void 0 ? _a : '', options.gtmId);
    const { privacyPolicyUrl } = getPrivacyConsentConfig((_b = domain === null || domain === void 0 ? void 0 : domain.configurationFields) !== null && _b !== void 0 ? _b : undefined, i18n.language);
    useEffect(() => {
        if (domain === null || domain === void 0 ? void 0 : domain.host) {
            captureCampaignAttribution(domain.host);
        }
    }, [domain === null || domain === void 0 ? void 0 : domain.host]);
    if (domain == null) {
        return null;
    }
    const context = {
        id: domain.id,
        name: domain.name,
        host: domain.host,
        href: domain.href,
        website: (_c = domain.website) !== null && _c !== void 0 ? _c : null,
        logo: domain.logo,
        icon: domain.icon,
        options,
        configurationFields: domain.configurationFields,
        plannedDateInfo: domain.plannedDateInfo,
        captcha: domain.captcha
    };
    return (React.createElement(DomainContext.Provider, { value: context },
        error ? (React.createElement(Error, { title: "Ooops!", infos: "An error occured while trying to load the domain.", picto: "fal bug", error: error })) : (props.children),
        gtm.showBanner && (React.createElement(CookieConsentBanner, { privacyPolicyUrl: privacyPolicyUrl, onChoice: gtm.updateConsent }))));
}
/**
 * @component DomainContext
 * @since 1.0.0
 */
export const DomainContext = createContext({
    id: '',
    name: '',
    host: '',
    href: '',
    website: null,
    logo: null,
    icon: null,
    options: {},
    configurationFields: [],
    plannedDateInfo: null,
    captcha: null
});
/**
 * @function useDomain
 * @since 1.0.0
 */
export function useDomain() {
    return useContext(DomainContext);
}
/**
 * @const DomainQuery
 * @since 1.0.0
 */
export const DomainQuery = gql `
  query DomainQuery($input: DomainInput!) {
    domain(input: $input) {
      ...DomainFragment
    }
  }

  ${DomainFragment}
`;
